export { default } from './ContactScraper';
